"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

class GithubAvatar extends _react.Component {
  constructor(props) {
    super(props);
    this.username = typeof GATSBY_GITHUB_USERNAME !== `undefined` && GATSBY_GITHUB_USERNAME !== '' ? GATSBY_GITHUB_USERNAME : '';
    const defaultId = GATSBY_GITHUB_AVATAR_DEFAULT;
    this.state = {
      username: '',
      imagePath: defaultId ? `https://avatars3.githubusercontent.com/u/${defaultId}?v=4` : ''
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  async componentDidMount() {
    const githubProfile = await (0, _axios.default)({
      method: 'GET',
      url: 'https://api.github.com/users/' + this.username
    });
    this.setState({
      imagePath: githubProfile.data.avatar_url
    });
  }

  render() {
    const {
      className
    } = this.props || {
      className: ''
    };
    const {
      imagePath
    } = this.state || {
      imagePath: ''
    };
    return _react.default.createElement("img", {
      className: className,
      src: imagePath,
      alt: "Github avatar"
    });
  }

}

exports.default = GithubAvatar;